import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext'; // AuthContextをインポート
import { Navigate } from 'react-router-dom'; // リダイレクト用
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  styled,
  CircularProgress
} from '@mui/material';
console.log("BASE:", process.env.REACT_APP_API_BASE_URL);
const StyledPaper = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(8),
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(10px)',
}));

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
}));

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { user, login, error, loading } = useAuth(); // AuthContextからユーザー情報とログイン機能を取得

  // ユーザーが既にログインしている場合はリダイレクト
  if (user) {
    return <Navigate to="/" />;
  }

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      await login(email, password);
      // login関数内でリダイレクトを処理するため、ここでの追加処理は不要
    } catch (err) {
      // エラーはlogin関数内で処理されるため、ここでは何もしない
    }
  };

  return (
    <StyledBox>
      <Container component="main" maxWidth="xs">
        <StyledPaper elevation={6}>
          <Typography component="h1" variant="h4" gutterBottom color="primary">
            工事予定表
          </Typography>
          <Box component="form" onSubmit={handleLogin} sx={{ mt: 3, width: '100%' }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="メールアドレス"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
              disabled={loading}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="パスワード"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 3 }}
              disabled={loading}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{
                mt: 2,
                mb: 2,
                height: '48px',
                fontSize: '1.1rem',
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'ログイン'
              )}
            </Button>
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
          </Box>
        </StyledPaper>
      </Container>
    </StyledBox>
  );
};

export default Login;
